
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Link, RichTextElement } from 'fsxa-api'
import BaseHeadline from './BaseHeadline.vue'
import { ILink } from '../../shared/general/interfaces/ILink'

export interface IBaseTable {
  headline ?: string
  content ?: RichTextElement[]
  matrixDesign ?: boolean
}

@Component({
  name: 'BaseTable',
  components: {
    BaseHeadline,
    BaseLink: () => import('./BaseLink.vue'),
  },
})
export default class BaseTable extends Vue {
  @Prop() headline ?: string

  @Prop({ default: () => [] }) content! : RichTextElement[]

  @Prop({ default: false }) matrixDesign! : boolean

  private componentTypes = {
    text: 'span',
    linebreak: 'br',
    link: 'BaseLink',
  }

  /**
   * Skip first element which relates to the table itself
   */
  private get table () : RichTextElement[] {
    if (!this.content.length || !(this.content[0].type === 'table') || typeof this.content[0].content === 'string') {
      return []
    }
    return this.content[0].content
  }

  private textStyle (baseContent : RichTextElement) : string | undefined {
    const isRecord = <T>(object : Link | Record<string, T>) : object is Link => 'member' in object
    if (isRecord(baseContent.data)) return undefined
    const res = {
      bold: 'font-bold',
      italic: 'italic',
    }
    return res[baseContent.data.format]
  }

  private getContent (baseContent : RichTextElement) : RichTextElement[] {
    if (!baseContent.content || typeof baseContent.content === 'string') return []
    return baseContent.content
  }

  private bindText (baseContent ?: RichTextElement) : string | undefined {
    const { content } = baseContent || {}

    switch (baseContent?.type || 'unknown') {
      case 'text':
      case 'bold':
      case 'italic':
        return typeof content === 'string' ? content : this.bindText(content?.[0])
      default:
        return undefined
    }
  }

  private bindLinkData (baseContent ?: RichTextElement) : ILink | undefined {
    switch (baseContent?.type || 'unknown') {
      case 'link':
        return baseContent?.data?.data || {}
      default:
        return undefined
    }
  }
}
